import { BehaviorSubject, Subscription } from "rxjs";
import { numberOrZero } from "../helpers/number.js";
import { cacheDb } from "../service/cache.js";

const carts = new BehaviorSubject({});

export function initCart(cart) {
  // console.log(cart,'::::');
  carts.next(cart ?? {});
}

export function addToCart(product, quantity = 1) {
  const id = product?.id ?? -1;
  const oldCarts = carts.value;
  const oldQuantity = numberOrZero(oldCarts[id]?.quantity ?? 0);
  const newCart = {
    ...oldCarts,
    [id]: {
      product,
      quantity: oldQuantity + numberOrZero(quantity)
    }
    // id: 'cart'
  };
  cacheDb.carts.put(newCart, "cart");
  carts.next(newCart);
}

export function removeFromCart(product, quantity = 1) {
  const id = product?.id ?? -1;
  const oldCarts = carts.value;
  const oldQuantity = numberOrZero(oldCarts[id]?.quantity ?? 0);
  const value = oldQuantity - numberOrZero(quantity);
  const newValue = {
    ...oldCarts,
    [id]: value > 0 ? {
      product,
      quantity: value
    } : undefined
    // id: 'cart'
  };
  cacheDb.carts.put(newValue, "cart");
  carts.next(newValue);
}

export function getAllCarts() {
  return Object.values(carts.value ?? {}).filter(x => x !== undefined);
}

export function totalItemsInCarts() {
  return Object
    .values(carts.value ?? {})
    .map(x => numberOrZero(x?.quantity))
    .reduce((a, b) => a + b, 0);
}

export function totalAmountInCarts() {
  return Object
    .values(carts.value ?? {})
    .map(x => numberOrZero(x?.product?.retailPrice) * numberOrZero(x?.quantity))
    .reduce((a, b) => a + b, 0);
}

/**
 *
 * @param observer {function}
 * @return {Subscription}
 */
export function cartChanges(observer = () => {
}) {
  return carts.subscribe(observer);
}

export function clearCart() {
  cacheDb.carts.put({}, "cart");
  carts.next({});
}